// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as ApiUtils$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/utils/ApiUtils.bs.js";
import * as CookieUtils$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/utils/CookieUtils.bs.js";
import * as AdminDetailsRepoConfig from "./AdminDetailsRepoConfig.bs.js";

function fetchAdminDetails(param) {
  var userCookie = CookieUtils$Catalyst.getCookie("user_roles");
  return new Promise((function (resolve, param) {
                  return resolve(userCookie);
                })).then(function (result) {
              return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                          return Curry._1(AdminDetailsRepoConfig.AdminDetailsResponseConverter.execute, {
                                      TAG: /* Success */0,
                                      _0: result
                                    });
                        });
            });
}

function fetchAdminConfig(param) {
  var userCookie = CookieUtils$Catalyst.getCookie("admin_config");
  return new Promise((function (resolve, param) {
                  return resolve(userCookie);
                })).then(function (result) {
              return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                          return Curry._1(AdminDetailsRepoConfig.AdminConfigResponseConverter.execute, {
                                      TAG: /* Success */0,
                                      _0: result
                                    });
                        });
            });
}

var AdminDetailsRepo = {
  fetchAdminDetails: fetchAdminDetails,
  fetchAdminConfig: fetchAdminConfig
};

export {
  AdminDetailsRepo ,
  
}
/* CookieUtils-Catalyst Not a pure module */
